import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { ClipboardService } from 'src/app/shared/services/clipboard.service';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})

export class FooterComponent implements OnInit {
  @ViewChild('tokenTooltip') tokenTooltip!: MatTooltip;
  private window: any;
  token: string = '';
  faCopy = faCopy;
  faExternalLink = faExternalLink;

  constructor(
    public router: Router, 
    @Inject(DOCUMENT) private document: Document,
    private clipboardService: ClipboardService
  ) {
    this.window = this.document.defaultView!;
  }
  
  ngOnInit() {
    const token = localStorage.getItem('token');
    if (token) {
      this.token = token;
    }
  }

  showConsentForm() {
    this.window.ctrack.openConsentCenter();
  }

  getAPIDocsLink() {
    return (environment.name === 'production') ? 'https://api.clearscape.teradata.com/api-docs' : `https://api.${environment.name}.clearscape.teradata.com/api-docs`;
  }

  copyToken() {
    this.clipboardService.copyToClipboard(localStorage.getItem("token")!, this.tokenTooltip);
  }

  requestSupport() {
    const subject = 'ClearScape Analytics Support Request';
    const body = 'Please describe your issue or question:\n\n';
    window.location.href = `mailto:SC230208@teradata.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }
}
